<template>
  <div
    :class="['punch-card-campaign-reward-item border position-relative d-flex align-items-center justify-content-between', { '-main-reward': isMainReward }]">
    <div class="campaign-reward-item-details flex-grow-1 d-flex align-items-center">
      <RewardCupIcon :isMain="isMainReward" />
      <div class="campaign-reward-item-info ml-2">
        <span class="reward-label position-absolute">
          <slot name="label"></slot>
        </span>
        <h3 class="reward-name mb-0">
          <slot name="name"></slot>
        </h3>
        <p class="rewards-expiry mb-0">
          <slot name="expiry">No expiry</slot>
        </p>
      </div>
    </div>
    <b-dropdown :id="`toggle-campaign-reward-item-action-${campaignRewardIndex}`" no-caret toggle-class="shadow-none">
      <b-dropdown-item @click="editReward(campaignRewardIndex)">Edit details</b-dropdown-item>
      <b-dropdown-item class="-delete"
        @click="$root.$emit('bv::show::modal', 'punch-card-confirm-delete-reward-modal', campaignRewardIndex)">Delete
        reward</b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import RewardCupIcon from './RewardCupIcon.vue';
import { mapFields } from "vuex-map-fields";

export default {
  props: ["campaignRewardIndex"],
  components: { RewardCupIcon },
  computed: {
    ...mapFields("punchCard", ["campaignData"]),
    isMainReward: {
      get() {
        return this.campaignData.design.milestones[this.campaignRewardIndex].reward_image;
      },
      set(value) {
        return value
      }
    }
  },
  methods: {
    editReward(index) {
      this.$root.$emit("bv::show::modal", "modal-punch-card-campaign-reward-modal", index);
    }
  }
}
</script>

<style lang="scss" scoped>
.punch-card-campaign-reward-item {
  border-radius: 10px;
  border-color: #C2C8CC !important;
  padding: 20px 8px;

  .reward-name {
    font-size: 16px;
    color: #2F3941;
  }

  .rewards-expiry {
    font-size: 14px;
    color: #2F3941;
  }

  .reward-label {
    top: -20px;
    left: 0;
    padding: 5px 8px;
    border-radius: 3px;
    color: #2ACFC6;
    background-color: #eafaf9;
  }

  &.-main-reward {
    .reward-label {
      color: #FF6B00;
      font-family: MainFontBold, sans-serif;
      font-size: 14px;
      background-color: #fff0e5;
    }
  }
}
</style>

<style lang="scss">
div[id^="toggle-campaign-reward-item-action-"] {
  .dropdown-toggle {
    padding: 0;
    border: 0;
    width: 20px;
    height: 20px;
    background: transparent url('~@/assets/images/icons/three-dots.svg') no-repeat center !important;
    transform: rotate(90deg);
    opacity: 0.5;
  }

  .dropdown-menu {
    width: 100px;
    padding: 0;
    font-size: 12px;

    .dropdown-item {
      &.-delete {
        color: #C30000;
      }
    }
  }
}
</style>
